import { useQuery } from "@tanstack/react-query";
import { ContractorPanelCardService } from "../services/contractorPanelCardService";
import { ReadContractorCard } from "@/types/contractorCard";
import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";

export const useContractorPanelCardQuery = (
  contractorCardId: string | undefined,
) => {
  const { can_read } = useModulePermissions(Module.ContractorPanelCards);

  const query = useQuery<ReadContractorCard>({
    queryKey: [Module.ContractorPanelCards, contractorCardId],
    queryFn: () => {
      if (!contractorCardId) {
        throw new Error("Contractor card ID is required");
      }
      return ContractorPanelCardService.get(contractorCardId);
    },
    enabled: !!contractorCardId && can_read,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    ...query,
    contractorCard: query.data,
  };
};
